import {useEffect} from "react";

/**
 * Locks body scroll for the lifetime of the calling component. Use in
 * full-screen / overlay components that are only mounted while "open"
 * (LiveLocationModal, RouteHistoryModal, PasscodeVerificationModal, ...).
 * Prevents iOS Safari's rubber-band scroll-chaining from scrolling the
 * page behind the overlay.
 */
export default function useScrollLock() {
  useEffect(() => {
    const {body, documentElement} = document;
    const prevOverflow = body.style.overflow;
    const prevOverscroll = documentElement.style.overscrollBehavior;

    body.style.overflow = "hidden";
    documentElement.style.overscrollBehavior = "none";

    return () => {
      body.style.overflow = prevOverflow;
      documentElement.style.overscrollBehavior = prevOverscroll;
    };
  }, []);
}
